'use client'
import { signIn } from 'next-auth/react'
import { useEffect } from 'react'

export default function SignInPage() {
  useEffect(() => void signIn('sub360', { callbackUrl: '/bids', redirect: true }), [])
  return null
}
